export const CREATOR_UNKNOWN = 'unknown' as const;
export const DEFAULT_MEASUREMENT_UNIT = 'IN' as const;

export const FREE_SHIPPING = 'FREE_SHIPPING' as const;
export const FREE_SHIPPING_AND_COST = 'FREE_SHIPPING_AND_COST' as const;
export const DEFAULT_SHIPPING_BADGE_TYPE = FREE_SHIPPING;

export const WIDTH_STATIC_TILE_IMAGE = 240;
